module.exports = __webpack_public_path__ + "static/rune_knight-60218ceec99b61ba73195c64f4125433.png";